import {
  GET_DEPARTMENT_OPTIONS,
  DEPARTMENT_OPTIONS_SUCCESS,
  DEPARTMENT_OPTIONS_ERROR,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_ERROR,
  CREATE_DEPARTMENT,
  GET_DEPARTMENT_LIST,
  DEPARTMENT_LIST_ERROR,
  DEPARTMENT_LIST_SUCCESS,
} from '../type';

const initialState = {
  departmentList: {
    loading: false,
    data: [],
    total:0,
    error: null,
  },
  spoc: [],
  shiftStartTime: [],
  shiftEndTime: [],
  location: [],
  error: null,
  loading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_DEPARTMENT_OPTIONS:
      return {
        ...state,
        loading: true,
      };
    case DEPARTMENT_OPTIONS_SUCCESS:
      return {
        ...state,
        spoc: action.payload.departmentSpoc,
        shiftStartTime: action.payload.shiftStartTime,
        shiftEndTime: action.payload.shiftEndTime,
        location: action.payload.location,
        loading: false,
      };
    case DEPARTMENT_OPTIONS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case CREATE_DEPARTMENT:
      return {
        ...state,
        loading: true,
      };
    case CREATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_DEPARTMENT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case GET_DEPARTMENT_LIST:
      return {
        ...state,
        departmentList: {
          ...state.departmentList,
          loading: true,
        },
      };
    case DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        departmentList: {
          ...state.departmentList,
          loading: false,
          data: action.payload.objectDept,
          total: action.payload.total,
        },
      };
    case DEPARTMENT_LIST_ERROR:
      return {
        ...state,
        departmentList: {
          ...state.departmentList,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
